var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "questionnaireTableCellInputContainer", class: _vm.classes },
    [
      _vm.template.type === "DATE"
        ? _c("question-date", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: _vm.validations,
                expression: "validations",
              },
            ],
            staticClass: "questionnaireTableCellInput",
            attrs: {
              id: _vm.template.id,
              name: _vm.template.id,
              placeholder: _vm.template.placeholder,
              value: _vm.vModel,
              readonly: !!_vm.template.readonly,
            },
            on: { blur: _vm.onChange },
          })
        : _c("question-text", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: _vm.validations,
                expression: "validations",
              },
            ],
            staticClass: "questionnaireTableCellInput",
            attrs: {
              id: _vm.template.id,
              name: _vm.template.id,
              placeholder: _vm.template.placeholder,
              value: _vm.vModel,
              readonly: !!_vm.template.readonly,
            },
            on: { input: _vm.onChange },
          }),
      _c("tooltip", {
        attrs: {
          ord: _vm.template.ord,
          title: _vm.template.name,
          description: _vm.template.description,
          required: !!_vm.isRequired,
          error: _vm.showErrors && _vm.errors.first(_vm.template.id),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }